// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__CUtpe","topBottomGutter":"Layout_topBottomGutter__1CCtm"};